import chess from "../images/ChessClass.jpg"
import { Link, useMatch, useResolvedPath } from "react-router-dom";

function CustomLink({to, children, ...props}) {
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch({path: resolvedPath.pathname, end: true})
    return (
        <li className={isActive ? "active" : ""}>
            <Link to={to} {...props}>
                {children}
            </Link>
        </li>
    )
}

export default function Chess() {
    return (
        <div className="playfair" style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
            <div className="classesBanner">
                <img src={chess} className="classesBanners" alt=""></img>
                <p style={{position:"absolute", margin: "0", color: "white", fontWeight: "900", fontSize: "clamp(1.8rem, 1.2109rem + 2.6182vw, 5.4rem)"}}>EXTRACURRICULAR</p>
            </div>
            <div className="backToHomeDivOther">
                <CustomLink to="/" className="backToHome">Home</CustomLink>
                <p style={{fontSize: "clamp(1.5rem, 0.9280rem + 0.6700vw, 2rem)", margin: "2rem 0 0"}}>&nbsp;&nbsp;/ </p>
                <CustomLink to="/classInfo" className="backToHome" style={{marginLeft: "0"}}>Class Information</CustomLink>
                <p style={{fontSize: "clamp(1.5rem, 0.9280rem + 0.6700vw, 2rem)", margin: "2rem 0 0"}}>&nbsp;&nbsp;/&nbsp;&nbsp;Extracurricular Class</p>
            </div>
            <div className="differentClasses">
                <div className="otherInfoDiv">
                    <p className="classesInfoTitle">Chess</p>
                    <p className="glacial">
                        This class is for students wanting to learn chess. This includes how each piece moves, beginner openings and fundamental chess strategies. There is an advanced class option for students who
                        are familiar with the basics of chess.
                    </p>
                </div>
                <div className="otherInfoDiv">
                    <p className="classesInfoTitle">Art</p>
                    <p className="glacial">
                        Students explore creativity through drawing, painting, and hands-on art projects. This class encourages self-expression, imagination, and confidence while learning basic art techniques.
                    </p>
                </div>
                <div className="otherInfoDiv">
                    <p className="classesInfoTitle">Basics of Graphic Design</p>
                    <p className="glacial">
                        Discover the fundamentals of graphic design through creativity and technology. Students will learn basic design pinciples, visual communication, and how to create meaningful designs. Students will explore storytelling, character development, and creative expression while building confidence in their writing skills.
                    </p>
                </div>
            </div>
        </div>
    )
}